export { default } from './ModeratorBadge';
